import { useQuery } from '@tanstack/react-query';

import { fetchVendorShipmentConfig } from '../data-provider/vendor-shipment-configuration';

type Params = { enabled: boolean; companyId: number };

export const useGetVendorShipmentConfig = ({ enabled = true, companyId }: Partial<Params>) => {
  return useQuery({
    enabled: enabled && Boolean(companyId),
    queryFn: () => fetchVendorShipmentConfig(),
    queryKey: ['vendor-shipment-config-visibility', companyId],
    // biome-ignore lint/style/noMagicNumbers: 15 min
    staleTime: 1000 * 60 * 15,
  });
};
